import axios from 'axios';

const MAX_ATTEMPTS = 3;

const isRetryable = (error) =>
  !error.response ||
  error.code === 'ECONNABORTED' ||
  error.code === 'ECONNRESET' ||
  error.code === 'ETIMEDOUT' ||
  error.code === 'EAI_AGAIN' ||
  [408, 429, 502, 503, 504].includes(error.response?.status);

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const postWithRetry = async ({
  url,
  payload,
  timeout,
  headers,
  maxAttempts = MAX_ATTEMPTS,
  onAttemptFailure,
}) => {
  let lastError;

  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    const startedAt = Date.now();

    try {
      const response = await axios.post(url, payload, {
        timeout,
        headers,
        validateStatus: (s) => s >= 200 && s < 300,
      });

      return {
        response,
        attempt,
        duration: Date.now() - startedAt,
      };
    } catch (error) {
      lastError = error;

      onAttemptFailure?.({
        error,
        attempt,
        duration: Date.now() - startedAt,
      });

      if (attempt === maxAttempts || !isRetryable(error)) {
        break;
      }

      await delay(500 * 2 ** (attempt - 1));
    }
  }

  throw lastError;
};